module.exports = __webpack_public_path__ + "img/parliament-4.188cc882.jpg";